import { render, staticRenderFns } from "./strengthCustomTab.vue?vue&type=template&id=df4c7578&"
import script from "./strengthCustomTab.vue?vue&type=script&lang=js&"
export * from "./strengthCustomTab.vue?vue&type=script&lang=js&"
import style0 from "./strengthCustomTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports